import { Component, ComponentFactoryResolver, ElementRef, OnInit, QueryList, ViewChild, ViewChildren, ViewContainerRef } from '@angular/core';
import { DomSanitizer, Meta } from '@angular/platform-browser';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { GeneralService } from 'src/app/core/services/general/general.service';
import { environment } from 'src/environments/environment';


import { BuscadorPosgradosComponent } from 'src/app/modules/posgrados/components/buscador-posgrados/buscador-posgrados.component';
import { AreasDeConocimientoComponent } from 'src/app/shared/widgets/areas-de-conocimiento/areas-de-conocimiento.component';
import { FormasDeContactoDosComponent } from 'src/app/shared/widgets/formas-de-contacto/formas-de-contacto-dos.component';
import { NuestrasSedesComponent } from 'src/app/shared/widgets/nuestras-sedes/nuestras-sedes.component';
import { PortadaComponent } from 'src/app/shared/widgets/portada/portada.component';
import { TextItemGeneralComponent } from 'src/app/shared/widgets/text-item-general/text-item-general.component';
import { SliderComponent } from 'src/app/shared/widgets/slider/slider.component';
import { BuscadorPosgradosTematicoComponent } from 'src/app/shared/components/buscador-posgrados-tematico/buscador-posgrados-tematico.component';
import { LoaderService } from 'src/app/core/load/load.service';
import { lastValueFrom, take } from 'rxjs';

@Component({
  selector: 'app-posgrados',
  templateUrl: './posgrados.component.html',
  styleUrls: ['./posgrados.component.scss']
})
export class PosgradosComponent implements OnInit {
  @ViewChildren('dynamicContainer', { read: ViewContainerRef }) containers!: QueryList<ViewContainerRef>;
  @ViewChildren('lazyWrapper', { read: ElementRef }) wrappers!: QueryList<ElementRef>;
  pages: any[] = [];
  nextIndex = 0;


  apiUrl: any;
  id: any;
  id_component: string;
  language: string;

  area: any;
  sede: any;
  refBuscador: any;


  constructor(private componentFactoryResolver: ComponentFactoryResolver, public activatedRoute: ActivatedRoute, public router: Router, public meta: Meta,
    public route: ActivatedRoute,
    public services: GeneralService,
    private loader: LoaderService,) {
    this.loader.setLoading(true);
    this.opcionsUrl();
  }
  ngAfterViewInit() {
    this.clearUrl();

    this.services.getSimplepage(this.id, this.language).subscribe(res => {
      this.area = res.data[0].area_posgrado;
      this.sede = res.data[0].region;

      // Convertimos el objeto de páginas en un array
      this.pages = Object.keys(res.data[0].pages)
        .filter(key => !isNaN(Number(key)))
        .map(key => res.data[0].pages[key][0]);

      // 🔹 Pre-cargar entidades
      this.preloadEntities().then(() => {
        // 🔹 Cuando todas estén listas, iniciar lazy load
        setTimeout(() => this.initSequentialLazyLoad(), 0);
      });
    })
  }
  ngOnInit(): void {
  }
  preloadedData: any;
  preloadEntities(): Promise<void> {
    const requests = this.pages.map(page => {
      const url = page.route + '&locale=' + this.language;

      return lastValueFrom(
        this.services.getEntities(url).pipe(take(1))
      ).catch(error => {
        console.error(`Error cargando la ruta: ${url}`, error);
        return null;
      });
    });

    return Promise.all(requests).then(results => {
      this.preloadedData = results;
    }).catch(err => {
      console.error("Error crítico en Promise.all:", err);
    });
  }

  initSequentialLazyLoad() {
    // Asegurarse de que nextIndex arranca en 0
    this.nextIndex = 0;

    const wrappersArray = this.wrappers.toArray();

    const loadNext = (index: number) => {
      if (index >= this.pages.length) {
        this.loader.setLoading(false);
        return
      };

      const wrapper = wrappersArray[index];
      if (!wrapper) return;

      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // Cargar datos
            const page = this.pages[index];
            const data = this.preloadedData[index];
            this.newComponent(index, page.entityType, data);
            // Fade-in al aparecer
            const currentWrapper = wrappersArray[index].nativeElement;
            currentWrapper.classList.add('loaded');
            (currentWrapper as HTMLElement).style.minHeight = "0px";


            // Avanzar al siguiente
            loadNext(index + 1);


            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0 }); // threshold 0 para disparar apenas aparece

      observer.observe(wrapper.nativeElement);
    };

    // arrancamos con el primero
    loadNext(this.nextIndex);
  }


  newComponent(index: number, type: string, info: any) {
    const container = this.containers.toArray()[index]; // obtenemos el ViewContainerRef correspondiente
    let ref: any;
    let factory;
    switch (type) {
      case "PortadaSedes": {
        // Configuración para "PortadaSedes"
        factory = this.componentFactoryResolver.resolveComponentFactory(PortadaComponent);
        ref = container.createComponent(factory);

        ref.instance.data = info.data[0];
        ref.instance.area = this.area;
        ref.instance.marginTitle = 40;
        ref.instance.heightDesk = "525px";
        ref.instance.heightMob = "370px";
        ref.instance.layerPathMob = info.data[0]?.cover?.pathMobileSuperpuesta;
        ref.instance.layerPath = info.data[0]?.cover?.pathSuperpuesta;

        break;
      }

      case "PortadaAreas": {
        // Configuración para "PortadaAreas"
        factory = this.componentFactoryResolver.resolveComponentFactory(PortadaComponent);
        ref = container.createComponent(factory);

        ref.instance.data = info.data[0];
        ref.instance.area = this.area;
        ref.instance.marginTitle = 75; // Valor ajustado para áreas
        ref.instance.heightDesk = "200px";
        ref.instance.heightMob = "250px";
        ref.instance.layerPathMob = info.data[0]?.cover?.pathMobileSuperpuesta;
        ref.instance.layerPath = info.data[0]?.cover?.pathSuperpuesta;

        break;
      }

      case "Portada": {
        // Configuración para "Portada" (por defecto)
        factory = this.componentFactoryResolver.resolveComponentFactory(PortadaComponent);
        ref = container.createComponent(factory);

        ref.instance.data = info.data[0];
        ref.instance.area = this.area;
        ref.instance.marginTitle = 75;
        ref.instance.heightDesk = "";
        ref.instance.heightMob = "";
        ref.instance.layerPathMob = info.data[0]?.cover?.pathMobileSuperpuesta;
        ref.instance.layerPath = info.data[0]?.cover?.pathSuperpuesta;

        break;
      }

      case 'Buscador': {
        let refBuscador;
        if (this.area) {
          let factory1 = this.componentFactoryResolver.resolveComponentFactory(BuscadorPosgradosTematicoComponent);
          refBuscador = container.createComponent(factory1);
        } else {
          let factory2 = this.componentFactoryResolver.resolveComponentFactory(BuscadorPosgradosComponent);
          refBuscador = container.createComponent(factory2);
        }

        this.refBuscador = refBuscador;
        this.refBuscador.instance.area = this.area;
        this.refBuscador.instance.sede = this.sede;
        this.refBuscador.instance.data = info.data;
        this.refBuscador.instance.translateY = (this.sede) ? "23%" : (this.area) ? "70%" : "52%";
        this.refBuscador.instance.padding = "30px 35.6px 30px 35.6px";

        this.refBuscador.changeDetectorRef.detectChanges();

      }
        break;
      case "AreaPosgrado": {

        factory = this.componentFactoryResolver.resolveComponentFactory(AreasDeConocimientoComponent);
        ref = container.createComponent(factory);
        const applyStyles = (areas: any[]) => {
          areas?.forEach(e => {
            e.backgroundColor = "#414141";
            e.colorName = "white";
          });
        };
        applyStyles(info.data[0].areas_tematicas_not_check_school);
        applyStyles(info.data[0].areas_tematicas_check_school);
        ref.instance.data = info.data[0];

      }
        break;
      case "Contacto": {
        factory = this.componentFactoryResolver.resolveComponentFactory(FormasDeContactoDosComponent);
        ref = container.createComponent(factory);
        ref.instance.data = info.data;
        ref.instance.esCurso = false
        ref.instance.color = 'gris'

      }
        break;
      case "Headquarters": {
        factory = this.componentFactoryResolver.resolveComponentFactory(NuestrasSedesComponent);
        ref = container.createComponent(factory);

        ref.instance.data = info.data[0].headquarters;
        ref.instance.sedes = info.data[0].sedes;
      }
        break
      case "ImageSlider": {
        factory = this.componentFactoryResolver.resolveComponentFactory(SliderComponent);
        ref = container.createComponent(factory);
        //ref.instance.ingreso = false;
        ref.instance.marginDesk = info.data[0].image.margin_desktop;
        ref.instance.marginMob = info.data[0].image.margin_mobile;
        ref.instance.images = info.data[0].image[0];
      }
        break
      case 'TextItem': {
        const factory = this.componentFactoryResolver.resolveComponentFactory(TextItemGeneralComponent);
        const ref = container.createComponent(factory);
        ref.instance.data = info.title;
        ref.instance.i = index;
        ref.changeDetectorRef.detectChanges();

      }
        break

    }






  }

  opcionsUrl() {
    this.apiUrl = environment.apiUrl;
    this.language = (this.activatedRoute.snapshot.params['language']) ? this.activatedRoute.snapshot.params['language'] : 'es';
    this.id_component = this.activatedRoute.snapshot.params['id'];
    let url = window.location.href;
    if (url.includes('#')) {
      let l = (this.activatedRoute.snapshot.params['language']) ? "/" + this.activatedRoute.snapshot.params['language'] : 'es';
      let index = url.indexOf("#")
      let palabra = url.slice((index + 1), url.length)
      window.location.href = "/" + l + "/busqueda/posgrados#" + palabra;
    }
  }
  clearUrl() {
    let relativeUrl = this.router.url.split('?')[0]; // Elimina los parámetros de la consulta
    const language = this.activatedRoute.snapshot.params['language'];
    if (language) {
      relativeUrl = relativeUrl.replace(`/${language}/`, '/').replace(`/${language}`, '/');
    }
    this.id = relativeUrl.startsWith('/') ? relativeUrl.substring(1) : relativeUrl;
  }
  SortArray(x, y) {
    if (x.title < y.title) { return -1; }
    if (x.title > y.title) { return 1; }
    return 0;
  }

}
